/**
 * Todo el balance vive aqui. Si vas a ajustar dificultad o ritmo, este es el
 * unico archivo que necesitas tocar.
 *
 * El modelo de tiempo viene de literatura de aritmetica mental:
 *   leer digitos ~0.42s, resolver una suma simple ~0.82s, operandos grandes
 *   1.5-3.0s, teclear dos digitos 0.6s en escritorio / 0.9s en movil, mas
 *   ~0.35s por cada roca que escaneas antes de elegir.
 * Total por objetivo (P): 2.3s facil en escritorio -> 5.0s dificil en movil.
 *
 * Dos reglas duras que salen de ahi:
 *   1. El intervalo de spawn nunca debe bajar de P. Si baja, la cola crece sin
 *      limite y la muerte es aritmetica, no habilidad.
 *   2. El tiempo de caida debe ser >= 2.5 * P, para que aplazar un objetivo sea
 *      una decision y no una sentencia.
 */

export const KILLS_PER_WAVE = 6;
export const INTERMISSION_MS = 2200;
export const FREEZE_MS = 5000;
export const MAX_CHARGES = 3;
export const WAVES_PER_CHARGE = 5;

export const START_LIVES = 3;

/** y de aparicion: fuera del borde superior, ya en movimiento */
export const SPAWN_Y = -90;

/** los candidatos (los que coinciden con lo que escribiste) bajan al 30% */
export const CAND_SLOW = 0.3;
/** y su deriva lateral baja al 15%, para que no pelee contra tu lectura */
export const CAND_SWAY = 0.15;

/** separacion entre disparos de una misma rafaga */
export const SHOT_STAGGER_MS = 95;
export const SHOT_SPEED = 1.2; // px por ms

/** rango de rotacion de la nave, en radianes (~72 grados) */
export const SHIP_MAX_ANGLE = 1.25;

/** respuestas de 2 a 4 digitos */
export const ANS_MIN = 10;
export const ANS_MAX = 9999;

/** multiplicador de caida por numero de etapas: index = stages */
export const STAGE_FALL = [1, 1, 1.8, 2.5];

/** el centro de dificultad sube para siempre, 0.55 bandas por ola */
export const BAND_SLOPE = 0.55;

export function centreFor(wave: number): number {
  return 1 + (wave - 1) * BAND_SLOPE;
}

export interface WaveParams {
  descent: number;
  spawn: number;
  maxAlive: number;
}

export function waveParams(wave: number): WaveParams {
  const over = Math.max(0, wave - 24);
  return {
    // piso de 6s: sigue apretando muy despacio pasada la ola 24
    descent: Math.max(6.0, 15 - (wave - 1) * 0.5 - Math.min(2, over * 0.06)),
    // piso de 3s: nunca por debajo del peor caso de P
    spawn: Math.max(3.0, 5.0 - (wave - 1) * 0.16),
    maxAlive: Math.min(6, wave < 3 ? 3 : wave < 6 ? 4 : wave < 12 ? 5 : 6),
  };
}

/** probabilidad de que una roca tenga varias etapas */
export const mutChance = (wave: number): number =>
  wave < 3 ? 0 : Math.min(0.45, 0.1 + (wave - 3) * 0.025);

/** dado que tiene varias etapas, probabilidad de que sean 3 en vez de 2 */
export const triChance = (wave: number): number =>
  wave < 8 ? 0 : Math.min(0.5, 0.12 + (wave - 8) * 0.03);
